import React, { useState, useEffect } from "react";
import { roomTypesColumns } from "./RoomTypesData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_ROOM_TYPE_REQUEST, GET_ROOM_TYPE_REQUEST } from "../../../../../../Utils/Constant";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import CommonDataTableFilterHeader from "../../../../../../Common/DataTableHeader/CommonDataTableFilterHeader";
import { useNavigate } from "react-router-dom";
import { hasDeleteAccess } from "../../../../../../Common/CheckAccess";

const RoomTypesTable = ({ shouldRefresh, setShouldRefresh, setSelectedRoom, selectedRoom, sidebarRef, isLoading }) => {
  const dispatch = useDispatch();
  const FilterOptions = ["Select", "Room Type", "Amenities", "Price", "Capacity"];

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Select");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const { roomTypes, deleteSuccess } = useSelector((state) => state.roomType);

  const [permissions, setPermissions] = useState([]);
      
        const existingPermissions = localStorage.getItem("checkPermission");
      
        useEffect(() => {
          if (existingPermissions != undefined) {
            const parsedData = JSON.parse(existingPermissions);
            setPermissions(parsedData);
          }
        }, [existingPermissions]);

  const handleView = (room) => {
    setSelectedRoom(room);
    sidebarRef.current?.openSidebar();
  };

  const handleOpenDelete = (room) => {
    setSelectedRoom(room);
    setShowDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedRoom?.id) {
      dispatch({ type: DELETE_ROOM_TYPE_REQUEST, payload: selectedRoom.id });
      setShouldRefresh(prev => !prev);
    }
    setShowDeleteDialog(false);
    setSelectedRoom(null);
  };
  useEffect(() => {
    setGlobalFilter("");
  }, [gloablFilterType]);


  useEffect(() => {
    setGlobalFilter("");
  }, [gloablFilterType]);

  useEffect(() => {
    const payload = {
      page: currentPage,
      limit: pageSize,
    };
    if (gloablFilterType === "Room Type" && globalFilter) {
      payload.room_type = globalFilter;
    } else if (gloablFilterType === "Amenities" && globalFilter) {
      payload.amenities = globalFilter;
    } else if (gloablFilterType === "Capacity" && globalFilter) {
      payload.capacity = globalFilter;
    } else if (gloablFilterType === "Price" && globalFilter) {
      const [start_price, end_price] = globalFilter.split("-").map(val => parseInt(val.trim()));
      if (!isNaN(start_price)) payload.start_price = start_price;
      if (!isNaN(end_price)) payload.end_price = end_price;
    }

    // Add hotel_id from localStorage
    const hotelId = localStorage.getItem('hotel_id');
    if (hotelId) {
      payload.hotel_id= hotelId;
    }
    dispatch({ type: GET_ROOM_TYPE_REQUEST, payload });
  }, [dispatch, currentPage, pageSize, globalFilter, gloablFilterType, shouldRefresh]);

  useEffect(() => {
    if (deleteSuccess) {
      setShouldRefresh(prev => !prev);
      dispatch({ type: "RESET_ROOM_TYPE_FLAGS" });
    }
  }, [deleteSuccess, dispatch]);

  useEffect(() => {
    if (roomTypes?.data?.rooms) {
      const transformed = roomTypes.data.rooms.map((room, index) => ({
        id: (currentPage - 1) * pageSize + index + 1,
        total_rooms: room.number_of_room || "-",
        room_type: room.room_type || "-",
        room_price: room.price || "-",
        capacity: room.capacity || "-",
        room_size: room.room_size ?`${room.room_size} m²` : "-",
        badge: room.offer_count || 0,
        actions: (
          <>
             {hasDeleteAccess(permissions, "rooms") &&  
             <button className="btn" onClick={() => handleOpenDelete(room)}>
              <i className="bi bi-trash text-danger"></i>
            </button>}
            <button className="btn" onClick={() => handleView(room)}>
              <i className="bi bi-eye text-primary"></i>
            </button>
          </>
        ),
      }));

      setData(transformed);
      setTotalEntries(roomTypes.data.pagination.totalResults || transformed.length);
    }
  }, [roomTypes, currentPage, pageSize]);

  const totalPages = Math.ceil(totalEntries / pageSize);
  const navigate = useNavigate();
  const columns = roomTypesColumns(navigate);
  return (
    <>
      <CommonDataTableFilterHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setCurrentPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        FilterOptions={FilterOptions}
        flage="roomStatus"
      />

      <DataTable
        columns={columns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={isLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />

      <ConfirmationATM
        show={showDeleteDialog}
        onClose={() => {
          setShowDeleteDialog(false);
          setSelectedRoom(null);
        }}
        onConfirm={handleConfirmDelete}
        message={`Are you sure you want to delete the "${selectedRoom?.room_type}" room type?`}
      />
    </>
  );
};

export default RoomTypesTable;
